<template>
  <div class="xqleft">
    <div class="chengshi">
      <div>郑州第一基站</div>
      <div style="font-size:14px"><img src="@/assets/dw.png" style="margin-right:10px">郑州</div>
    </div>
    <div class="llist">
      <ul>
        <li>
          <h1 class="mingcheng">负载大小</h1>
          <h2 class="shuzhi">{{ info.station_load }}<span class="danwei">KW</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">电池配置容量</h1>
          <h2 class="shuzhi" style="font-size: 18px; padding-bottom: 10px">
            {{ info.rated_capacity }}
          </h2>
        </li>
        <li>
          <h1 class="mingcheng">最低备电时长1</h1>
          <h2 class="shuzhi">{{ info.min_distribution_time }}<span class="danwei">小时</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">最低备电时长2</h1>
          <h2 class="shuzhi"><span class="danwei">小时</span></h2>
        </li>
      </ul>
    </div>
    <div class="quxian">
      峰谷时段实时策略
    </div>
    <div style="width: 100%">
      <table style="width: 90%; margin: 20px 5%">
        <tr>
          <td class="tbtd">{{ dianjia.topMonthes }}月份</td>
          <td class="tbtd">时段</td>
          <td class="tbtd">电价（元/kW·h）</td>
        </tr>
        <tr>
          <td class="jianfeng" style="background-color: #031c37">尖峰</td>
          <td class="shiduan">
            <div style="line-height: 40px;border-bottom: 1px rgba(56, 242, 254, 0.5) solid;">
              {{ $filters.formatTime(dianjia.top1DatetimeStart) }}-{{ $filters.formatTime(dianjia.top1DatetimeEnd) }}
            </div>
            <div style="line-height: 40px">19:00-21:00</div>
          </td>
          <td class="dianjia">{{ dianjia.peakPeakPrice }}</td>
        </tr>
        <tr>
          <td class="jianfeng" style="background-color: #031c37">高峰</td>
          <td class="shiduan">
            <div style="
                line-height: 40px;
                border-bottom: 1px rgba(56, 242, 254, 0.5) solid;">
              09:00-11:00
            </div>
            <div style="line-height: 40px">21:00-23:00</div>
          </td>
          <td class="dianjia">0.6887</td>
        </tr>
        <tr>
          <td class="jianfeng" style="background-color: #031c37">平段</td>
          <td class="shiduan">
            <div style="
                line-height: 40px;
                border-bottom: 1px rgba(56, 242, 254, 0.5) solid;
              ">
              09:00-11:00
            </div>
            <div style="line-height: 40px">21:00-23:00</div>
          </td>
          <td class="dianjia">0.6887</td>
        </tr>
        <tr>
          <td class="jianfeng" style="background-color: #031c37">低谷</td>
          <td class="shiduan">
            <div style="
                line-height: 40px;
                border-bottom: 1px rgba(56, 242, 254, 0.5) solid;
              ">
              09:00-11:00
            </div>
            <div style="line-height: 40px">21:00-23:00</div>
          </td>
          <td class="dianjia">0.6887</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import http from "@/api/http";
import { defineComponent, ref, onMounted } from "vue";
//import * as echarts from 'echarts';

import { useStore } from "vuex";
export default defineComponent({
  components: {

  },
  props: { info: Object },
  setup() {
    const options = ref({});
    const store = useStore()
    let stationid = store.getters['User/stationid']
    let dianjia = ref({})
    const getData = () => {
      http.get("/peak_valley_setting/" + stationid).then((res) => {
        console.log('0002', res)
        dianjia.value = res.data

      });
    };



    onMounted(() => {
      //组件挂载时的生命周期执行的方法
      getData();
    });



    return {
      options, dianjia,
    };
  },
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.xqleft {


  background: url("@/assets/bjk2.png");
  background-size: 100% 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.jianfeng {
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  border: 1px rgba(43,
      133,
      228, 0.5) solid;
  background-color: #031d39;
}

.dianjia {
  border: 1px rgba(43,
      133,
      228, 0.5) solid;
  text-align: center;
  background-color: #031d39;
}

.shiduan {
  border: 1px rgba(43, 133, 228, 0.5) solid;
  text-align: center;
  background-color: #031d39;
}

.tbtd {
  width: 20%;
  text-align: center;
  line-height: 35px;
  background-color: #031d39;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  border: 1px rgba(43, 133, 228, 0.5) solid;
}

.quxian {
  background: url("@/assets/biaoti.png") no-repeat;
  font-size: 14px;
  color: #fff;
  font-weight: bold;

  padding-left: 20px;

  margin: 25px 20px 0px;
}


.chengshi {
  padding-top: 36px;
  display: flex;
  padding-left: 30px;
  padding-right: 20px;
  font-size: 16px;
  font-weight: bold;
  justify-content: space-between;
  background: url("@/assets/xian3.png") no-repeat bottom center;
  padding-bottom: 10px;


}

.llist {
  padding: 20px 20px 0;
}

.llist ul li {
  float: left;
  list-style: none;
  width: 100%;
  color: #fff;
  display: flex;
  padding: 5px 10px;
  justify-content: space-between
}

.mingcheng {
  color: #c0c3c9;
  font-size: 15px;
  padding: 0;
  margin: 0;
}

.shuzhi {
  color: #2489ff;
  font-size: 15px;
  padding: 0;
  margin: 0;
  font-weight: bold;
}

.ziti {
  font-size: 24px;
  font-family: "denmark";
}

.danwei {
  color: #2489ff;
  font-size: 12px;
  padding-left: 10px;
  font-weight: bold;
}
</style>
